// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Timeline-module__timeline-list--tRfWV{color:#7b7f83}.Timeline-module__timeline-list--tRfWV>:last-child::before{content:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"timeline-list": `Timeline-module__timeline-list--tRfWV`,
	"timelineList": `Timeline-module__timeline-list--tRfWV`
};
export default ___CSS_LOADER_EXPORT___;
